import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface LanguageSpecificationListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
}

const defaultFilters: LanguageSpecificationListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "name",
    sortOrder: "asc"
};

export const useLanguageSpecificationListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<LanguageSpecificationListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<LanguageSpecificationListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [filters]);

    const setSort = (sort: ListTableSort): void => {
        setFilters((prevFilters: LanguageSpecificationListingFilters) => ({
            ...prevFilters,
            page: 1,
            sortBy: sort.by,
            sortOrder: sort.order
        }));
    };

    const setPage = (page: number) => {
        setFilters(
            (prevFilters: LanguageSpecificationListingFilters): LanguageSpecificationListingFilters => ({
                ...prevFilters,
                page
            })
        );
    };

    const setPageSize = (pageSize: number): void => {
        setFilters(
            (prevFilters: LanguageSpecificationListingFilters): LanguageSpecificationListingFilters => ({
                ...prevFilters,
                pageSize,
                page: 1
            })
        );
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setSort,
        setPage,
        setPageSize,
        clearFilters
    };
};
